export enum AddressOptions {
    SHIPPING = 'Shipping',
    ORIGINALADDRESS = 'originalAddress',
    SUGGESTEDADDRESS = 'suggestedAddress'
}

export enum AddressSchemaFormFrameworkType {
    BOOTSTRAP4 = 'bootstrap-4'
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/address-type.enum.ts